require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./2018-chamber-series.json") })
        }
      }, "path---2018-chamber-series");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---2018-chamber-series!./.cache/json/2018-chamber-series.json
// module id = 453
// module chunks = 231608221292675